export default __webpack_public_path__ + "static/media/logo192.739e8877.png";